module.exports = __webpack_public_path__ + "338eab270a2428bcabe985a88def1c2f.svg";